// extracted by mini-css-extract-plugin
module.exports = {"links":"footer_links__AhExO","btnSignUp":"footer_btnSignUp__bb4VJ","emailInput":"footer_emailInput__X7ZuQ"};